// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1OQyr","right":"styles_right__372K4"};